module.exports = __webpack_public_path__ + "img/icon-volume-open.70a691f1.png";